import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32da8ffb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "error-page flex justify-center mg-t-50 pd-t-50"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "404 | Juker", -1));
const _hoisted_3 = {
  class: "box w-500 flex align-center direction-column"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "404", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [/*#__PURE__*/_createElementVNode("span", null, "P"), /*#__PURE__*/_createTextVNode("age "), /*#__PURE__*/_createElementVNode("span", null, "N"), /*#__PURE__*/_createTextVNode("ot "), /*#__PURE__*/_createElementVNode("span", null, "F"), /*#__PURE__*/_createTextVNode("ound")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeadTag = _resolveComponent("HeadTag");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_HeadTag, null, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createVNode(_component_router_link, {
    to: $data.locationPath,
    class: "btn btn--orange"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.textBtn), 1)]),
    _: 1
  }, 8, ["to"])])]);
}